import { render, staticRenderFns } from "./EncounterBasicInfo.vue?vue&type=template&id=161740b5&"
import script from "./EncounterBasicInfo.vue?vue&type=script&lang=js&"
export * from "./EncounterBasicInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports